
import type { SVGProps } from 'react';
const SvgShop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#shop_svg__a)">
      <path
        fill="#263E6A"
        d="M19.068 6.306a.866.866 0 0 0-.858-.817h-2.786V4.374A2.377 2.377 0 0 0 13.05 2h-1.242a2.377 2.377 0 0 0-2.374 2.374v3.029a2 2 0 0 0-.282.075l-.026.009a2.08 2.08 0 0 0-1.188 1.07 2.08 2.08 0 0 0-.089 1.596l2.403 6.822a.323.323 0 0 0 .41.196l3.362-1.184a.323.323 0 0 0 .197-.41l-2.403-6.822a2.09 2.09 0 0 0-1.74-1.38V6.11h3.401a.322.322 0 0 0 0-.643h-3.401V4.374c0-.955.776-1.731 1.73-1.731h1.242c.955 0 1.731.776 1.731 1.73v3.008a.322.322 0 0 0 .643 0V6.132h2.786c.11 0 .21.095.215.203l.639 14.048a.164.164 0 0 1-.169.174H5.812a.164.164 0 0 1-.168-.174l.638-14.048a.22.22 0 0 1 .215-.203h1.37a.322.322 0 0 0 0-.643h-1.37a.866.866 0 0 0-.858.817l-.638 14.048a.807.807 0 0 0 .811.846h13.083a.807.807 0 0 0 .811-.846zM11.21 8.968l2.297 6.519-2.756.97L8.456 9.94a1.44 1.44 0 0 1 .062-1.105c.167-.35.46-.613.821-.74l.026-.01q.035-.011.07-.02v.57a1 1 0 0 0-.252.176.78.78 0 0 0-.227.474.87.87 0 0 0 .487.892.85.85 0 0 0 .363.082c.231 0 .46-.095.637-.274a.78.78 0 0 0 .217-.454.87.87 0 0 0-.582-.94v-.568c.505.082.951.43 1.133.946m-1.616.382a.14.14 0 0 1 .04-.083.24.24 0 0 1 .172-.08c.042 0 .075.013.094.023.043.02.138.085.12.246a.14.14 0 0 1-.037.076c-.114.116-.224.082-.267.062-.042-.02-.138-.084-.122-.244"
      />
    </g>
    <defs>
      <clipPath id="shop_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgShop;
